import httpService from "../util/httpService";

export const fetchListOfUsers = async (selectedCustomer) => {
  const data = await httpService.get(
    `/au/api/users?selectedCustomerId=${selectedCustomer}`
  );
  return data;
};

//not in use
export const fetchDownloadURLForLicenses = async (meta) => {
  let downloadConfig = {};
  return downloadConfig;
};

export const createNewUser = async (values, selectedCustomer) => {
  const requestBody = { ...values };
  const { data } = await httpService.post(
    `/au/api/user?selectedCustomerId=${selectedCustomer}`,
    requestBody
  );
  return data;
};

export const editUser = async (values, selectedCustomer) => {
  const requestBody = { ...values };
  const { data } = await httpService.put(
    `/au/api/user/${values.userRowId}?selectedCustomerId=${selectedCustomer}`,
    requestBody
  );
  return data;
};

export const uploadBulkDataForUsers = async (
  formData,
  config,
  selectedCustomer
) => {
  const data = await httpService.post(
    `/au/api/users?selectedCustomerId=${selectedCustomer}`,
    formData,
    config
  );
  return data;
};
export const invokeBulkActionForUsers = (transactionId) => {
  const data = httpService.post(
    `/au/api/processBulkUserTransaction/${transactionId}`
  );
};

export const fetchBulkUsersTransactions = async (selectedCustomer) => {
  const { data } = await httpService.get(
    `/au/api/bulkUserTransactions?selectedCustomerId=${selectedCustomer}`
  );
  return data.map((t) => ({
    key: String(t.bulkUserImportTransactionRowId),
    ...t,
    children: [],
    nestedTableChildren: [t.userImportStatusDTOs],
  }));
};

export const updateUserPrefrences = async (values) => {
  const requestBody = { ...values };
  const { data } = await httpService.post(
    `/au/api/userpreferences`,
    requestBody
  );
  return data;
};

export const updateUserLang = async (values) => {
  const { data } = await httpService.post(
    `/au/api/userpreferences/updateUserLanguage?language=${values}`
  );
  return data;
};
export const deleteUserAPI = async (objectId) => {
  const data = await httpService.delete(`/au/api/user?objectId=${objectId}`);
  return data;
};

export const resetPasswordAPI = async (objectId, selectedCustomerId) => {
  const data = await httpService.post(`/au/api/user/resetUserPassword?objectId=${objectId}&selectedCustomerId=${selectedCustomerId}`);
  return data;
};

export const fetchLegalAgreementStatus = async () => {
  const { data } = await httpService.post(`/om/api/contractmanagement/legalagreement`);
  return data; // Expected: { isAgreed: true/false, ... }
  //return {"showLegalAgreement": true}
};

export const saveLegalAgreementAcceptance = async (info) => {
  const requestBody = {
    "legalAgreementRowId": 0,
    "customerId": info.customerId,
    "designation": info.designation,
    "agreedByName": info.agreedByName,
    "isAgreed": true,
  };
  const { data } = await httpService.post(`/om/api/contractmanagement/legalagreement`, requestBody);
  return data;
};